module.exports = require('./dist/server/document')



//////////////////
// WEBPACK FOOTER
// ../node_modules/next/document.js
// module id = ../node_modules/next/document.js
// module chunks = 1